import { ca } from '@cian/analytics';

export function trackMapInViewportClick(isNewbuildingMvkEnabled: boolean) {
  ca('event', {
    action: isNewbuildingMvkEnabled ? 'master_podbora_show_map' : 'show_map',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackGeoAddressNodeClick() {
  ca('event', {
    action: 'click_address_map_block',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackGeoUndergroundClick() {
  ca('event', {
    action: 'click_metro_map_block',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackTabMapClick() {
  ca('event', {
    action: 'click_tab_on_map',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackTabPanoramaClick() {
  ca('event', {
    action: 'click_tab_panorama',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackTabSimilarClick() {
  ca('event', {
    action: 'click_tab_similar_on_map',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackSpecialProjectClick(project: string) {
  ca('event', {
    action: `${project}_jk_on_map`,
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackTabFloorPlanClick() {
  ca('event', {
    action: 'click_tab_on_floor',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackInteractivePlanClick() {
  ca('event', {
    action: 'click_interactive_plan',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
